import { Grid } from '@mui/material'
import { SimpleForm,  BooleanInput, useTranslate, TextInput, required } from 'react-admin'
// import dayjs from 'dayjs'
import { COMMON_FIELDS , PARTNER_ICONS_FIELDS} from '../../providers/localization/constant'
import { CreateBase } from '../../components/base'
// import { isAfterDate, isBeforeDate } from '../../utils/validators'
import {
//   ActionSelectInput,
FormBottomToolbarWithPermission,
//   PublicNewsSelectInput,
//   TargetLinkSelectInput,
//   TextInputTargetValue,
} from '../../components/form'
import { IconImageInput } from '../../components/inputs/IconImageInput'

const ParthnerIconCreate = (): JSX.Element => {
    const translate = useTranslate()
//   const defaultDate = dayjs()
//   const defaultExpireDate = defaultDate.add(1, 'month')
  const postDefaultValue = (): object => ({ publish_condition: 'a' })
  return (
    <CreateBase
      title={`${PARTNER_ICONS_FIELDS}.create.title`}
      listAction={{
        hasBackButton: true,
      }}
      encType='multipart/form-data'
    >
      <SimpleForm
        toolbar={
            <FormBottomToolbarWithPermission encType='multipart/form-data' hasConfirm={true} isCreate={true} />
          }
        defaultValues={postDefaultValue}
      >
        <TextInput 
          label={translate(`${COMMON_FIELDS}.order`)} 
          source='order' 
          fullWidth
          validate={[required()]} 
        />
        <Grid item>
          <BooleanInput
            color='primary'
            source='is_active'
            label={`${COMMON_FIELDS}.status.label`}
          />
        </Grid>
        <Grid container spacing={2} alignItems='flex-start' justifyContent='center'>
          <Grid item xs={12} sm={6}>
            <IconImageInput
                label={translate(`${PARTNER_ICONS_FIELDS}.icon`)}
                initCrop={false}
                fallbackSource='full_path'
                source='icon'
              />
          </Grid>
        </Grid>
      </SimpleForm>
    </CreateBase>
  )
}

export default ParthnerIconCreate